export default __webpack_public_path__ + "static/media/julian_coffee.5f722b16.svg";